var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticStyle: { width: "72%" } }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c("span", [_vm._v("Pieces")]),
                  _c("el-input-number", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      value: _vm.cargoDoc.quantity || undefined,
                      no: "quantity",
                      min: 0,
                      max: 999999999999,
                      precision: 0,
                      disabled: !_vm.isEdit,
                      "controls-position": "right",
                      controls: false
                    },
                    on: {
                      input: function(val) {
                        _vm.cargoDoc.quantity = val
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c("span", [_vm._v("Gross Weight")]),
                  _c("el-input-number", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      value: _vm.cargoDoc.weight || undefined,
                      no: "weight",
                      min: 0,
                      max: 999999999999,
                      precision: 3,
                      disabled: !_vm.isEdit,
                      controls: false,
                      "controls-position": "right"
                    },
                    on: {
                      input: function(val) {
                        _vm.cargoDoc.weight = val
                      },
                      change: function($event) {
                        _vm.weightChangeHandler
                        _vm.commonChangeHandler("weight")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-right": "2px"
                  }
                },
                [
                  _c("span", [_vm._v("KG-LB")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { disabled: !_vm.isEdit, no: "kglb" },
                      model: {
                        value: _vm.cargoDoc.kglb,
                        callback: function($$v) {
                          _vm.$set(_vm.cargoDoc, "kglb", $$v)
                        },
                        expression: "cargoDoc.kglb"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "K", value: "K" } }),
                      _c("el-option", { attrs: { label: "L", value: "L" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-right": "2px"
                  }
                },
                [
                  _c("span", [_vm._v("Rate Class")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70px" },
                      attrs: {
                        disabled: !_vm.isEdit,
                        no: "rateClass",
                        placeholder: !_vm.isEdit
                          ? ""
                          : _vm.$t("SeaExport.PleaseSelect")
                      },
                      on: { change: _vm.rateClassChangeHandler },
                      model: {
                        value: _vm.cargoDoc.rateClass,
                        callback: function($$v) {
                          _vm.$set(_vm.cargoDoc, "rateClass", $$v)
                        },
                        expression: "cargoDoc.rateClass"
                      }
                    },
                    _vm._l(_vm.AirExportConstants.RATE_CLASSES, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c("span", [_vm._v("C.Weight")]),
                  _c("el-input-number", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      value: _vm.cargoDoc.cWeight || undefined,
                      no: "cWeight",
                      min: 0,
                      max: 999999999999,
                      precision: 1,
                      disabled: !_vm.isEdit,
                      "controls-position": "right",
                      controls: false
                    },
                    on: {
                      input: function(val) {
                        _vm.cargoDoc.cWeight = val || 0
                      },
                      change: function($event) {
                        _vm.cWeightChangeHandler()
                        _vm.commonChangeHandler("cWeight")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    width: "100px",
                    "margin-right": "2px"
                  }
                },
                [
                  _c("span", [_vm._v("Rate Charge")]),
                  _c("cargo-input", {
                    attrs: {
                      disabled: !_vm.isEdit,
                      no: "rateCharge",
                      "auto-uppercase": true
                    },
                    on: {
                      change: function($event) {
                        return _vm.commonChangeHandler("rateCharge")
                      }
                    },
                    model: {
                      value: _vm.cargoDoc.rateCharge,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "rateCharge", $$v)
                      },
                      expression: "cargoDoc.rateCharge"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    width: "100px"
                  }
                },
                [
                  _c("span", [_vm._v("Total")]),
                  _c("cargo-input", {
                    attrs: {
                      disabled: !_vm.isEdit,
                      no: "cTotal",
                      "auto-uppercase": true
                    },
                    model: {
                      value: _vm.cargoDoc.cTotal,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "cTotal", $$v)
                      },
                      expression: "cargoDoc.cTotal"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("div", [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Remark")]),
                _c("cargo-rich-textarea", {
                  staticStyle: { height: "186px" },
                  attrs: {
                    no: "remark1",
                    "text-chars": 0,
                    "auto-uppercase": _vm.isUppercaseByConfig,
                    "warning-count": -1,
                    disabled: !_vm.isEdit
                  },
                  nativeOn: {
                    dblclick: function($event) {
                      return _vm.showAdvanceTextDialog(
                        "Remark",
                        _vm.cargoDoc.remark1,
                        function(val) {
                          _vm.cargoDoc.remark1 = val
                        }
                      )
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.remark1,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "remark1", $$v)
                    },
                    expression: "cargoDoc.remark1"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          {
            staticStyle: {
              "flex-grow": "1",
              width: "28%",
              "margin-left": "5px"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Nature and Quantity of Goods")]),
                _c("cargo-rich-textarea", {
                  attrs: {
                    no: "cargoEnglishName",
                    disabled: !_vm.isEdit,
                    "auto-uppercase": _vm.isUppercaseByConfig,
                    "text-chars": 0,
                    "warning-count": -1
                  },
                  nativeOn: {
                    dblclick: function($event) {
                      return _vm.showAdvanceTextDialog(
                        "Nature and Quantity of Goods",
                        _vm.cargoDoc.cargoEnglishName,
                        function(val) {
                          _vm.cargoDoc.cargoEnglishName = val
                        }
                      )
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cargoEnglishName,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cargoEnglishName", $$v)
                    },
                    expression: "cargoDoc.cargoEnglishName"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Dimension")]),
                _c("cargo-rich-textarea", {
                  staticStyle: { height: "110px" },
                  attrs: {
                    no: "dimension",
                    disabled: !_vm.isEdit,
                    "text-chars": 0,
                    "auto-uppercase": true,
                    "warning-count": -1
                  },
                  nativeOn: {
                    dblclick: function($event) {
                      return _vm.showAdvanceTextDialog(
                        "Dimension",
                        _vm.cargoDoc.dimension,
                        function(val) {
                          _vm.cargoDoc.dimension = val
                        }
                      )
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.dimension,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "dimension", $$v)
                    },
                    expression: "cargoDoc.dimension"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Volume")]),
                _c("el-input-number", {
                  staticStyle: { width: "100%", "margin-right": "5px" },
                  attrs: {
                    value: _vm.cargoDoc.cubage || undefined,
                    no: "cubage",
                    min: 0,
                    max: 999999999999,
                    precision: 3,
                    disabled: !_vm.isEdit,
                    "controls-position": "right",
                    controls: false
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cubage = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("cubage")
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticStyle: { "margin-right": "5px" } }, [
          _c("div", [
            _vm._m(0),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "pp1",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.PP
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp1 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP1")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp1,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp1", $$v)
                    },
                    expression: "cargoDoc.pp1"
                  }
                }),
                _c("cargo-input", {
                  attrs: {
                    no: "cc1",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.CC
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc1 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC1")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc1,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc1", $$v)
                    },
                    expression: "cargoDoc.cc1"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(1),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "pp2",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.PP
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp2 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP2")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp2,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp2", $$v)
                    },
                    expression: "cargoDoc.pp2"
                  }
                }),
                _c("cargo-input", {
                  attrs: {
                    no: "cc2",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.CC
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc2 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC2")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc2,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc2", $$v)
                    },
                    expression: "cargoDoc.cc2"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(2),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "pp3",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.PP
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp3 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP3")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp3,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp3", $$v)
                    },
                    expression: "cargoDoc.pp3"
                  }
                }),
                _c("cargo-input", {
                  attrs: {
                    no: "cc3",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.CC
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc3 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC3")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc3,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc3", $$v)
                    },
                    expression: "cargoDoc.cc3"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(3),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "pp4",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.other !== _vm.AirExportConstants.PP
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp4 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP4")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp4,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp4", $$v)
                    },
                    expression: "cargoDoc.pp4"
                  }
                }),
                _c("cargo-input", {
                  attrs: {
                    no: "cc4",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.other !== _vm.AirExportConstants.CC
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc4 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC4")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc4,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc4", $$v)
                    },
                    expression: "cargoDoc.cc4"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(4),
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "center" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: { no: "pp5", "auto-uppercase": true, disabled: true },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp5 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP5")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp5,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp5", $$v)
                    },
                    expression: "cargoDoc.pp5"
                  }
                }),
                _c("cargo-input", {
                  attrs: { no: "cc5", "auto-uppercase": true, disabled: true },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc5 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC5")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc5,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc5", $$v)
                    },
                    expression: "cargoDoc.cc5"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(5),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "pp6",
                    "auto-uppercase": true
                  },
                  on: {
                    change: function($event) {
                      return _vm.commonChangeHandler("PP6")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp6,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp6", $$v)
                    },
                    expression: "cargoDoc.pp6"
                  }
                }),
                _c("cargo-input", {
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "cc6",
                    "auto-uppercase": true
                  },
                  model: {
                    value: _vm.cargoDoc.cc6,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc6", $$v)
                    },
                    expression: "cargoDoc.cc6"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c("div", [
          _c(
            "div",
            [
              _c("other-charge-grid", {
                attrs: {
                  "cargo-doc": _vm.cargoDoc,
                  action: _vm.action,
                  job: _vm.job
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "7px" } },
            [
              _c("span", [_vm._v("Signature of Shipper or his Agent")]),
              _c("cargo-input", {
                attrs: {
                  disabled: !_vm.isEdit,
                  no: "signByShipper",
                  "auto-uppercase": true
                },
                model: {
                  value: _vm.cargoDoc.signByShipper,
                  callback: function($$v) {
                    _vm.$set(_vm.cargoDoc, "signByShipper", $$v)
                  },
                  expression: "cargoDoc.signByShipper"
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-right": "2px",
                  display: "flex",
                  "flex-direction": "column"
                }
              },
              [
                _c("span", [_vm._v("Executed on (date)")]),
                _c("el-date-picker", {
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "signDateBL",
                    editable: false,
                    clearable: false,
                    type: "date",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd"
                  },
                  model: {
                    value: _vm.cargoDoc.signDateBL,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "signDateBL", $$v)
                    },
                    expression: "cargoDoc.signDateBL"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-right": "2px" } },
              [
                _c("span", [_vm._v("at (place)")]),
                _c("cargo-input", {
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "signPlaceBL",
                    "auto-uppercase": true
                  },
                  model: {
                    value: _vm.cargoDoc.signPlaceBL,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "signPlaceBL", $$v)
                    },
                    expression: "cargoDoc.signPlaceBL"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              [
                _c("span", [
                  _vm._v("Signature of Issuing Carrier or its Agent")
                ]),
                _c("cargo-input", {
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "signByCarrier",
                    "auto-uppercase": true
                  },
                  model: {
                    value: _vm.cargoDoc.signByCarrier,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "signByCarrier", $$v)
                    },
                    expression: "cargoDoc.signByCarrier"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: { disabled: !_vm.isEdit },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "confirm" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-around" } },
      [
        _c("span", [_vm._v("Prepaid")]),
        _c("span", [_vm._v("Weight Charge")]),
        _c("span", [_vm._v("Collect")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "center" } },
      [_c("span", [_vm._v("Valuation")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "center" } },
      [_c("span", [_vm._v("Tax")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "center" } },
      [_c("span", [_vm._v("Total other Charges Due Agent")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "center",
          "padding-top": "7px"
        }
      },
      [_c("span", [_vm._v("Total other Charges Due Carrier")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-around" } },
      [
        _c("span", [_vm._v("Total prepaid")]),
        _c("span", [_vm._v("Total collect")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }